import { render, staticRenderFns } from "./NewMegaMenuModal.vue?vue&type=template&id=42f7d9df"
import script from "./NewMegaMenuModal.vue?vue&type=script&lang=js"
export * from "./NewMegaMenuModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports